var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileText = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30945 3.28686C5.82599 2.7818 6.52424 2.5 7.25 2.5H16.25C16.3807 2.5 16.5061 2.55115 16.5996 2.6425L23.3496 9.2425C23.4458 9.33657 23.5 9.46544 23.5 9.6V22.8C23.5 23.5198 23.2075 24.2077 22.6905 24.7131C22.174 25.2182 21.4758 25.5 20.75 25.5H7.25C6.52423 25.5 5.82599 25.2182 5.30945 24.7131C4.79253 24.2077 4.5 23.5198 4.5 22.8V5.2C4.5 4.48024 4.79253 3.7923 5.30945 3.28686ZM7.25 3.5C6.78229 3.5 6.33594 3.68177 6.00857 4.00187C5.68158 4.32159 5.5 4.7528 5.5 5.2V22.8C5.5 23.2472 5.68158 23.6784 6.00857 23.9981C6.33594 24.3182 6.78229 24.5 7.25 24.5H20.75C21.2177 24.5 21.6641 24.3182 21.9914 23.9981C22.3184 23.6784 22.5 23.2472 22.5 22.8V10.1H16.25C15.9739 10.1 15.75 9.87614 15.75 9.6V3.5H7.25ZM16.75 4.18818L21.7735 9.1H16.75V4.18818ZM9 10.7C9 10.4239 9.22386 10.2 9.5 10.2H11.75C12.0261 10.2 12.25 10.4239 12.25 10.7C12.25 10.9761 12.0261 11.2 11.75 11.2H9.5C9.22386 11.2 9 10.9761 9 10.7ZM9 15.1C9 14.8239 9.22386 14.6 9.5 14.6H18.5C18.7761 14.6 19 14.8239 19 15.1C19 15.3761 18.7761 15.6 18.5 15.6H9.5C9.22386 15.6 9 15.3761 9 15.1ZM9 19.5C9 19.2239 9.22386 19 9.5 19H18.5C18.7761 19 19 19.2239 19 19.5C19 19.7761 18.7761 20 18.5 20H9.5C9.22386 20 9 19.7761 9 19.5Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-text.bcee404f.svg";
export { ForwardRef as ReactComponent };